import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { fmtDate } from "../../lib/dateUtil";
import { GraduationCap, Lock, ArrowRight } from "@phosphor-icons/react";

/** Training assigned to me that still needs doing — overdue and locked courses flagged. Hidden when there's nothing pending.
 *  `openTo` is where "Open my training" goes: engineers → My safety, office roles → HSE → Training. */
export function MyTrainingCard({ openTo = "/health-safety?tab=training", className = "", testid = "my-training-card" }) {
  const [data, setData] = useState(null);
  useEffect(() => { API.get("/hse/training/mine").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  const todo = (data?.assignments || []).filter((a) => a.status !== "passed");
  if (!todo.length) return null;
  const overdue = todo.filter((a) => a.overdue).length;
  const locked = todo.filter((a) => a.locked).length;
  return (
    <div className={`rounded-lg border p-5 ${overdue || locked ? "border-red-200 bg-red-50/60 dark:bg-red-950/20" : "border-amber-200 bg-amber-50/60 dark:bg-amber-950/20"} ${className}`} data-testid={testid}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <p className="text-xs uppercase tracking-wide font-semibold text-slate-600 dark:text-slate-300 flex items-center gap-1"><GraduationCap className="h-4 w-4" weight="bold" /> My training</p>
          <p className="text-sm text-slate-700 dark:text-slate-200 mt-1" data-testid={`${testid}-summary`}>{todo.length} course{todo.length === 1 ? "" : "s"} to complete{overdue ? ` · ${overdue} overdue` : ""}{locked ? ` · ${locked} locked (ask your manager)` : ""}</p>
        </div>
        <Link to={openTo}><Button variant="outline" data-testid={`${testid}-open`}>Open my training <ArrowRight className="h-4 w-4 ml-2" /></Button></Link>
      </div>
      <div className="mt-3 space-y-1.5">
        {todo.slice(0, 3).map((a) => (
          <Link key={a.id} to={`/my-work/training/${a.id}`} className="flex items-center justify-between gap-2 rounded-md border border-border bg-card px-3 py-2 text-sm hover:border-primary/50" data-testid={`${testid}-row-${a.id}`}>
            <span className="font-medium truncate">{a.course_title}</span>
            <span className={`text-xs shrink-0 ${a.locked || a.overdue ? "text-red-600 font-medium" : "text-slate-500"}`}>{a.locked ? <span className="inline-flex items-center gap-1"><Lock className="h-3 w-3" /> Locked</span> : a.overdue ? `Overdue · due ${fmtDate(a.due)}` : a.due ? `Due ${fmtDate(a.due)}` : a.status === "in_progress" ? "In progress" : "Start"}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
